export default {
	title: "Unarchive this goal?",
	description: "Your goal will be unarchived and made editable. It will also show up in the list of active or future goals.",
	confirmButton: "Unarchive goal",
	dismissButton: "Do not unarchive",
};
